const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        slides: {
          perView: 3.5,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 4.5,
              spacing: 0,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 6,
              spacing: 0,
            },
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
